import { InfoCircleFilled } from '@ant-design/icons';
import { Heading } from '@mm/components';
import React from 'react';
import styles from './ExplainerButton.module.css';

type Props = {
  buttonName: string;
  showExplainer: boolean;
  setShowExplainer: (yes: boolean) => void;
};

export const ExplainerButton = (props: Props) => {
  const { buttonName, showExplainer, setShowExplainer } = props;

  return (
    <>
      <div
        className={styles.explanerButton}
        onMouseOver={() => setShowExplainer(true)}
        onFocus={() => setShowExplainer(true)}
        onTouchStart={() => setShowExplainer(true)}
        onMouseLeave={() => setShowExplainer(false)}
        onTouchEnd={() => setShowExplainer(false)}
      >
        {buttonName}
      </div>
      {showExplainer && (
        <div className={styles.content}>
          <Heading size={5} className={styles.heading}>
            <InfoCircleFilled className={styles.infoCircle} />
            To this account / To other accounts / Shared externally:
          </Heading>
          <ul className={styles.list}>
            <li>Facebook & Instagram DM autoresponders are not cloned</li>
            <li>
              Facebook & Instagram Engagements autoresponders are not cloned
            </li>
            <li>Web Visitor Email detector is not cloned</li>
            <li>Click-to-Messenger Ads autoresponders are not cloned</li>
            <li>
              Website Chat Widget autoresponder clonned with default display
              rules
            </li>
            <li>
              Comment, Live Comment, Story Reactions autoresponders cloned as
              respond to all comments
            </li>
            <li>
              Keyword only cloned if the same keyword not yet exists on the
              account
            </li>
            <li>
              Manually upload contacts list trigger is not cloned to other
              accounts
            </li>
          </ul>
        </div>
      )}
    </>
  );
};
